<template>
  <li
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      @click="checkDev(item)"
    >
      <feather-icon v-if="item.icon == 'CircleIcon'" :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate" v-bind:class="{'text-white':isAdmin}">{{ item.title }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    
    <b-modal
          ref="modal-dev"
          centered
          title="Vertically Centered"
          :hide-footer="true"
          :hide-header="true"
          size="md"
        >
    <div class="d-flex flex-column align-items-center">
      <div class="align-self-end"> 
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-secondary"
          class="btn-icon"
          size="md"
          @click="$refs['modal-dev'].hide()"
        >
          <feather-icon icon="XIcon" />
        </b-button>
      </div>
      <div class="h2 text-danger mb-2">
        Notice
      </div>
      <b-card-text class="mb-2">
        <p>
          Feature "{{modalText}}" currently under development
        </p>
      </b-card-text>
    </div>
    </b-modal>
  </li>
</template>

<script>
// import { ref } from '@vue/composition-api'
import { BLink, BBadge, BModal, BButton, BCardText, } from 'bootstrap-vue'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BCardText,
    BLink,
    BBadge,
    BModal,
    BButton,
  },
  data() {
    return {
      modalText: ''
    }
  },
  computed: {
    isAdmin: {
      get() {
        return this.$store.state.app.isAdmin;
      }
    }
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)

    return {
      isActive,
      linkProps,
      updateIsActive,
    }
  },
  methods: {
    checkDev(item){
      // if(item.title == 'Discussion'){
      //   this.modalText = item.title;
      //   this.$refs['modal-dev'].show()
      // }
    }
  }
}
</script>

<style>
.text-white {
  color: white;
}
</style>
